import React from 'react';
import { useCustomNotifications } from '../CustomNotificationContext';
import CustomNotification from '../CustomNotification';
import SimplePopperPopover from '@wix/da-ds/pkg/popper/presets/SimplePopperPopover';
const offsetModifier = [
    0,
    8
];
const PopoverNotification = ({ notificationTypes, className, contentClassName, customNotificationRender, notificationFilter, children, isVisible, placement = 'top', secondaryPlacement = 'start' })=>{
    const { notifications } = useCustomNotifications(notificationTypes);
    const hasNotification = !!notificationTypes && (!notificationFilter || notifications.some(notificationFilter));
    return /*#__PURE__*/ React.createElement(SimplePopperPopover, {
        isVisible: hasNotification && isVisible,
        showArrow: true,
        placement: placement,
        secondaryPlacement: secondaryPlacement,
        offsetModifier: offsetModifier,
        className: className,
        contentClassName: contentClassName,
        popoverContent: /*#__PURE__*/ React.createElement(CustomNotification, {
            notificationTypes: notificationTypes,
            customNotificationRender: customNotificationRender,
            notificationFilter: notificationFilter
        })
    }, children);
};
PopoverNotification.displayName = 'PopoverNotification';
export default PopoverNotification;
